import React from 'react';
import { motion } from 'framer-motion';
import { Cloud, Server, CheckCircle2 } from 'lucide-react';
export function Slide10Deployment() {
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-20 md:pb-28 relative overflow-hidden" data-id="element-12">
      <header className="mb-16 text-center" data-id="element-13">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-14">
          Flexible deployment depending on Takeda’s compliance needs.
        </motion.h2>
        <motion.p className="text-xl text-[#4A5568] font-light max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-15">
          The deployment model can be selected based on pilot scope, data
          sensitivity and internal governance.
        </motion.p>
      </header>

      <main className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto w-full" data-id="element-16">
        {/* Option A */}
        <motion.div className="bg-white rounded-2xl p-10 shadow-sm border-2 border-[#6B46C1]/20 flex flex-col relative overflow-hidden" initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-17">
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#6B46C1]/5 rounded-bl-full pointer-events-none" data-id="element-18" />

          <div className="flex items-center gap-4 mb-8" data-id="element-19">
            <div className="p-4 bg-[#6B46C1]/10 rounded-xl" data-id="element-20">
              <Cloud className="w-8 h-8 text-[#6B46C1]" data-id="element-21" />
            </div>
            <div data-id="element-22">
              <div className="text-sm font-bold text-[#6B46C1] uppercase tracking-wider mb-1" data-id="element-23">
                Option A
              </div>
              <h3 className="text-2xl font-bold text-[#1A202C]" data-id="element-24">
                Snakker-hosted
              </h3>
            </div>
          </div>

          <div className="space-y-4 flex-1" data-id="element-25">
            {['Fastest route', 'Standard compliance review', 'Snakker dashboard and reporting'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-26">
                <CheckCircle2 className="w-5 h-5 text-[#6B46C1] shrink-0 mt-0.5" data-id="element-27" />
                <span className="text-[#4A5568]" data-id="element-28">{item}</span>
              </div>)}
          </div>

          <div className="mt-8 p-4 bg-gray-50 rounded-xl border border-gray-100" data-id="element-29">
            <p className="text-sm font-medium text-[#2D3748]" data-id="element-30">
              <strong className="text-[#1A202C]" data-id="element-31">Recommended for:</strong> fast
              pilots and lower-risk use cases
            </p>
          </div>
        </motion.div>

        {/* Option B */}
        <motion.div className="bg-white rounded-2xl p-10 shadow-sm border-2 border-[#E60012]/20 flex flex-col relative overflow-hidden" initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-32">
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#E60012]/5 rounded-bl-full pointer-events-none" data-id="element-33" />

          <div className="flex items-center gap-4 mb-8" data-id="element-34">
            <div className="p-4 bg-[#E60012]/10 rounded-xl" data-id="element-35">
              <Server className="w-8 h-8 text-[#E60012]" data-id="element-36" />
            </div>
            <div data-id="element-37">
              <div className="text-sm font-bold text-[#E60012] uppercase tracking-wider mb-1" data-id="element-38">
                Option B
              </div>
              <h3 className="text-2xl font-bold text-[#1A202C]" data-id="element-39">
                Takeda-controlled
              </h3>
            </div>
          </div>

          <div className="space-y-4 flex-1" data-id="element-40">
            {['Higher internal control', 'Suitable for stricter data governance', 'Snakker supports setup and reporting remotely'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-41">
                <CheckCircle2 className="w-5 h-5 text-[#E60012] shrink-0 mt-0.5" data-id="element-42" />
                <span className="text-[#4A5568]" data-id="element-43">{item}</span>
              </div>)}
          </div>

          <div className="mt-8 p-4 bg-gray-50 rounded-xl border border-gray-100" data-id="element-44">
            <p className="text-sm font-medium text-[#2D3748]" data-id="element-45">
              <strong className="text-[#1A202C]" data-id="element-46">Recommended when:</strong> data
              ownership requirements are stricter
            </p>
          </div>
        </motion.div>
      </main>

      <motion.footer className="mt-12 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 0.8
    }} data-id="element-47">
        <p className="text-[#4A5568] font-medium" data-id="element-48">
          Early alignment on deployment helps accelerate project start.
        </p>
      </motion.footer>
    </div>;
}